/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useRef, useEffect, useState } from "react";
import { PivotControls, useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { ILocation } from "../models/general.model";
import { useControls } from "leva";
import { IHotspot } from "../models/hotspot.model";
import ReactGA from "react-ga4";

type GLTFResult = GLTF & {
  nodes: {
    Circle: THREE.Mesh;
    Circle001: THREE.Mesh;
  };
  materials: {
    ["Material.001"]: THREE.MeshStandardMaterial;
  };
};

interface IProps {
  hotspot: IHotspot;
  onHotspotClick: any;
}

export function Movement({ hotspot, onHotspotClick }: IProps) {
  const [hovered, setHovered] = useState(false);
  // @ts-ignore
  const { nodes }: any = useGLTF("/movement.glb") as GLTFResult;

  //const { nodes } = useGLTF("/movement.glb");

  // const controller = useControls({
  //   [`${hotspot.id}-x`]: { value: hotspot.position.x, min: -100, max: 100 },
  //   [`${hotspot.id}-y`]: { value: hotspot.position.y, min: -100, max: 100 },
  //   [`${hotspot.id}-z`]: { value: hotspot.position.z, min: -100, max: 100 },
  //   [`${hotspot.id}-r-x`]: {
  //     value: hotspot.rotation.x,
  //     min: -0.1,
  //     max: 0.1,
  //   },
  //   [`${hotspot.id}-r-y`]: {
  //     value: hotspot.rotation.y,
  //     min: -0.1,
  //     max: 0.1,
  //   },
  //   [`${hotspot.id}-r-z`]: {
  //     value: hotspot.rotation.z,
  //     min: -0.1,
  //     max: 0.1,
  //   },
  //   [`${hotspot.id}-scale`]: { value: hotspot.scale, min: 0, max: 20 },
  // });

  useEffect(() => {
    // console.log("hovered: ", hovered);
    document.body.style.cursor = hovered ? "pointer" : "grab";
  }, [hovered]);

  return (
    <>
      <group
        dispose={null}
        // scale={controller[`${hotspot.id}-scale`]}
        scale={hotspot.scale}
        // position={[
        //   controller[`${hotspot.id}-x`],
        //   controller[`${hotspot.id}-y`],
        //   controller[`${hotspot.id}-z`],
        // ]}
        position={[hotspot.position.x, hotspot.position.y, hotspot.position.z]}
        onClick={() => {
          onHotspotClick();
          ReactGA.event({
            category: "movement-hotspot-clicked",
            action: JSON.stringify(hotspot),
          });
        }}
        // rotation={[
        //   controller[`${hotspot.id}-r-x`],
        //   controller[`${hotspot.id}-r-y`],
        //   controller[`${hotspot.id}-r-z`],
        // ]}
        rotation={[hotspot.rotation.x, hotspot.rotation.y, hotspot.rotation.z]}
        onPointerOver={() => setHovered(true)}
        onPointerOut={() => setHovered(false)}
      >
        <mesh
          geometry={new THREE.CylinderGeometry(1, 1, 0.5, 12)}
          material={
            new THREE.MeshBasicMaterial({
              // color: 0xaaaaaa,
              // wireframe: true,
              visible: false,
            })
          }
          position={[-3.54, -0.05, 0]}
          scale={1}
        />
        <mesh
          geometry={nodes.Circle.geometry}
          material={
            new THREE.MeshBasicMaterial({
              color: 0xffffff,
              opacity: hovered ? 0.9 : 0.5,
              transparent: true,
            })
          }
          position={[-3.54, -0.05, 0]}
          scale={hovered ? [1.5, 0.28, 1.5] : [1, 0.23, 1]}
        />
        <mesh
          geometry={nodes.Circle001.geometry}
          material={
            new THREE.MeshBasicMaterial({
              color: 0xffffff,
              opacity: hovered ? 0.9 : 0.5,
              transparent: true,
            })
          }
          position={[-3.54, -0.09, 0]}
          scale={hovered ? [1.5, 0.28, 1.5] : [1, 0.23, 1]}
        />
      </group>
    </>
  );
}

useGLTF.preload("/movement.glb");
